export const DEFAULT_BUCKETS = [
  { id: "0", name: "Entertainment Videos" },
  { id: "1", name: "Educational Videos" },
  { id: "2", name: "Funny Videos" },
  { id: "3", name: "Vlogs" },
  { id: "4", name: "Product Reviews" },
];
